import {
    CORE_LOAD_MASTER_DATA_COIL_TYPES_REQUEST,
    CORE_LOAD_MASTER_DATA_COIL_TYPES_SUCCESS,
    CORE_LOAD_MASTER_DATA_COIL_TYPES_FAILURE,

    CORE_LOAD_MASTER_DATA_COIL_TYPE_REQUEST,
    CORE_LOAD_MASTER_DATA_COIL_TYPE_SUCCESS,
    CORE_LOAD_MASTER_DATA_COIL_TYPE_FAILURE,

} from '../../masterDataTypes'
import { REQUEST_STATE } from '../../types'

const requestState = REQUEST_STATE

export default {
    masterCoilTypes: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_COIL_TYPES_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_COIL_TYPES_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_LOAD_MASTER_DATA_COIL_TYPES_FAILURE:
                return []
            default:
                return state
        }
    },
    masterCoilType: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_COIL_TYPE_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_COIL_TYPE_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_LOAD_MASTER_DATA_COIL_TYPE_FAILURE:
                return {}
            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/masterDatas/coiltype.js